/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const DisabledIconOutline = createIcon({
  displayName: 'DisabledIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0 0h24v24h-24v-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M7.415 20.415l-3.829-3.829c-.375-.375-.586-.884-.586-1.414v-6.344c0-.53.211-1.039.585-1.413l3.829-3.829c.375-.375.884-.586 1.414-.586h6.342c.531 0 1.04.211 1.415.586l3.828 3.828c.376.376.587.886.587 1.417v6.34c0 .53-.211 1.038-.585 1.413l-3.829 3.83c-.375.375-.884.586-1.415.586h-6.343c-.53 0-1.039-.211-1.413-.585Z"
        ></path>
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M5.751 18.249l12.498-12.498"></path>
      </g>
    </>
  ),
})

const Disabled: FC<CustomIconProps> = (props) => {
  switch (props.variant || 'outline') {
    default:
      return <CustomIcon as={DisabledIconOutline} color="red.500" {...props} />
  }
}

export default memo(Disabled)
